angular
    .module('tradersyard')
    .factory('forum-summary-filter', [
        '$flex',
        function ($flex) {
            var knowing = ['unread-topics', 'changed-topics', 'most-active-topics', 'unanswered'];
            var hash = $flex.$hash.get();

            var params = {
                page: 0,
                scope: knowing.indexOf(hash) !== -1 ? hash : 'unread-topics',
                limit: 25,
            };

            var filter = {
                init: function () {
                    var hash = $flex.$hash.get();

                    filter.set(knowing.indexOf(hash) !== -1 ? hash : 'unread-topics');
                },
                is: function (name) {
                    return params.scope === name;
                },
                set: function (name) {
                    params.page = 0;
                    params.scope = name;

                    if (filter.on.change) filter.on.change();

                    if ($flex.$hash.get() !== name) $flex.$hash.set(name);
                },
                params: params,
                on: {
                    change: undefined,
                },
            };

            return filter;
        },
    ])
    .controller('forum-query-ctrl', [
        '$scope',
        'graph-forum-factory',
        'webinar-query-filter',
        '$flex',
        function ($scope, $factory, $filter, $flex) {
            angular.extend($scope, $flex.data);
        },
    ])
    .controller('forum-summary-ctrl', [
        '$scope',
        'graph-forum-factory',
        '$flex',
        'forum-summary-filter',
        function ($scope, $factory, $flex, $filter) {
            $scope.filter = $filter;
            $scope.nodes = [];
            $scope.loading = false;

            angular.extend($scope, $flex.data);

            $scope.query = function (next) {
                ++$filter.params.page;
                $scope.loading = true;

                $factory.summary({ params: $filter.params }).then(function (response) {
                    if (response.data.state === 0 && response.data.data.length > 0) {
                        $scope.nodes = $scope.nodes.concat(response.data.data);

                        if (next) next();
                    }

                    $scope.loading = false;
                });
            };

            $filter.on.change = function () {
                $scope.nodes = [];
                $filter.params.page = 0;
                $flex.$scroll.renew('topic');
                $scope.query();
            };

            $scope.$on('$historyBack', $filter.init);
        },
    ]);
